import React from "react";
import { Link } from "react-router-dom";
import motabilityLogo from '../../assets/img/logos/motability-scheme.svg';

const LogoHeader = ({ homeTo = '/' }) => {
    return (
        <header className="bg-primary sticky-top py-11 py-xl-4" id="main-header">
            <div className="navigation">
                <div className="container-fluid px-0">
                    <nav className="navbar py-0 ps-3 ps-xxl-96 pe-xxl-264">
                        <Link className="navbar-brand py-0 me-xl-29" to={homeTo}>
                            <img
                                src={motabilityLogo}
                                alt="Motability Scheme"
                                className="img-fluid w-144 w-xl-auto"
                                width="350"
                                height="90"
                                fetchPriority="low"
                                decoding="async"
                                loading="lazy"
                            />
                        </Link>
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default LogoHeader; 